import { Box, Flex } from "@chakra-ui/layout";
import { Skeleton, Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { TipoVeiculo, VeiculoForm } from "core/features/veiculo/typings";
import { Control, UseFormWatch } from "react-hook-form";
import ShadowSelectableButton from "ui/components/Button/ShadowSelectableButton";
import Field from "ui/components/Input/Field";
import InputFile from "ui/components/Input/InputFile";
import SelectCorVeiculo from "./SelectCorVeiculo";
import SelectMarcaVeiculo from "./SelectMarcaVeiculo";
import SelectModeloVeiculo from "./SelectModeloVeiculo";

interface FormVeiculoProps {
  control: Control<VeiculoForm, object>;
  watch: UseFormWatch<VeiculoForm>;
  tiposVeiculo?: TipoVeiculo[];
}

function FormVeiculo({ control, watch, tiposVeiculo }: FormVeiculoProps) {
  const form = watch();

  const marcaVeiculoId = form.marcaVeiculoId;
  const tipoVeiculoId = form.tipoVeiculoId;
  const foto = form.foto;

  return (
    <>
      <Box as={Row} mb={4}>
        <Field
          control={control}
          name="tipoVeiculoId"
          rules={{ required: "Campo obrigatório" }}
          render={({ field }) => (
            <Row gutter={[16, 16]}>
              {tiposVeiculo ? (
                tiposVeiculo.map((t) => (
                  <Box as={Col} xs={6} key={t.id}>
                    <ShadowSelectableButton
                      selected={tipoVeiculoId === t.id}
                      onClick={() => field.onChange(t.id)}
                      onUnselect={() => field.onChange(undefined)}
                    >
                      {t.nome}
                    </ShadowSelectableButton>
                  </Box>
                ))
              ) : (
                <>
                  <SkeletonCard />
                  <SkeletonCard />
                  <SkeletonCard />
                  <SkeletonCard />
                </>
              )}
            </Row>
          )}
        />
      </Box>

      <Box as={Row} mb={6} gutter={36}>
        <Box as={Col} xs={13}>
          <Field
            label="Marca"
            control={control}
            name="marcaVeiculoId"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectMarcaVeiculo {...field} isInvalid={isInvalid} />
            )}
          />
        </Box>

        <Box as={Col} xs={11}>
          <Field
            label="Modelo"
            control={control}
            name="modeloVeiculoId"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectModeloVeiculo
                {...field}
                isInvalid={isInvalid}
                marcaId={marcaVeiculoId}
              />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} mb={6} gutter={36}>
        <Box as={Col} xs={13}>
          <Field
            label="Placa"
            control={control}
            name="placa"
            rules={{ required: "Campo obrigatório" }}
          />
        </Box>

        <Box as={Col} xs={11}>
          <Field
            label="Cor"
            control={control}
            name="cor"
            render={({ field, isInvalid }) => (
              <SelectCorVeiculo {...field} isInvalid={isInvalid} />
            )}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={36} mb={6}>
        <Box as={Col} xs={24}>
          <Field
            shouldUnregister
            label="Observação"
            control={control}
            name="observacao"
            inputProps={{
              placeholder: "Escreva a observação...",
            }}
          />
        </Box>
      </Box>

      <Flex mt={8} flexDir="column">
        <Text as="h3" mb={2} fontWeight="500" fontSize={18}>
          Arquivos
        </Text>
        <Box as={Row} gutter={16}>
          <Box as={Col} xs={9}>
            <Field
              label="Foto"
              control={control}
              name="foto"
              render={({ field }) => (
                <InputFile
                  showPreview
                  label="Anexar foto"
                  value={field.value}
                  onChange={field.onChange}
                  accept="image/*"
                  name={
                    typeof foto === "string"
                      ? foto.split("/").pop()
                      : foto?.name
                  }
                />
              )}
            />
          </Box>
        </Box>
      </Flex>
    </>
  );
}

const SkeletonCard = () => (
  <Box as={Col} xs={6}>
    <Skeleton w="100%" py={12} rounded={16} />
  </Box>
);

export default FormVeiculo;
